/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';

import Editor from '../fw/Editor.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'screenEdit.title', 'defaultMessage': 'Editing screen'}
});

interface ScreenEditProps {
    intl: IntlShape;
    user: User;
}

class ScreenEdit extends React.Component<ScreenEditProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'screens';

    constructor(props) {
        super(props);
    }

    render() {
        let data = this.props.user.organisation.channel.screen;
        let type = types[this.typeName];

        let entities = this.props.user.organisation.channel.channelDef.channelEntityDefs.edges.map(({node}) => node);

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['channels'], data: this.props.user.organisation.channel},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <Editor
                    columns={{
                        'channelEntityDef': {
                            display: (item) => {
                                return item['entityDef']['name'] + " (" + item['entityDef']['groupDef']['name'] + ")";
                            },
                            values: entities,
                        },
                        'operation': {},
                        'subOperation': {},
                    }}
                    data={data}
                    fatQuery={Relay.QL `fragment on UpdateScreenPayload {
                        updatedNode {
                            id,
                            organisation_id,
                            organisation {
                                id,
                                name
                            },
                            channelEntityDef_id,
                            channelEntityDef {
                                id,
                                entityDef {
                                    id,
                                    name
                                }
                            },
                            channel_id,
                            channel {
                                id,
                                name
                            },
                            subOperation,
                            operation,
                            content,
                        },
                    }`}
                    metadata={type}
                    mutation={Relay.QL `mutation { updateScreen }`}
                    organisationId={this.props.user.organisation.realId}
                    parent={this.props.user.organisation.channel}
                    redirectToList
                    urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ScreenEdit), (props) => {
    return props.user.organisation && props.user.organisation.channel && props.user.organisation.channel.screen;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        screenId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channel(id: $channelId) {
                        id,
                        name,
                        organisation_id,
                        screen(id: $screenId) {
                            id,
                            organisation_id,
                            organisation {
                                id,
                                name
                            },
                            channelEntityDef {
                                id,
                                entityDef {
                                    id,
                                    name
                                }
                            },
                            channel_id,
                            channel {
                                id,
                                name
                            },
                            subOperation,
                            operation,
                            content,
                        },
                        channelDef {
                            id,
                            channelEntityDefs(first: 100) {
                                edges {
                                    node {
                                        id,
                                        entityDef {
                                            id,
                                            name,
                                            groupDef {
                                                id,
                                                name
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
            }
        `,
    },
});
